import { type IChildServiceDec, type IServiceDec } from '@App/types/servicesTypes'

export const onGetServicesByTitle = (list: IServiceDec[], serviceName: string) => {
    const result: IChildServiceDec[] = []
    const onNestingHandler = (list: IServiceDec[], serviceName: string) => {
        for (let i = 0; i <= list.length - 1; i++) {
            const item = list[i]
            if (item.childServices.length > 0) {
                item.childServices.forEach((srv) => {
                    // if (srv.code.toLowerCase().includes(serviceName.toLowerCase())) {
                    //     result.push(srv)
                    // }
                    if (srv.code.toLowerCase() === serviceName.toLowerCase()) {
                        result.push(srv)
                    }
                    const strList = serviceName.toLowerCase().match(/(?:\-?[а-яА-ЯёЁa-zA-Z]+\-?)|\d+/g)
                    if (strList && strList.every((el) => srv.name.toLowerCase().includes(el))) {
                        result.push(srv)
                    }
                })
            }

            if (item.childCategories.length > 0) {
                onNestingHandler(item.childCategories, serviceName)
            }
        }
        return result
    }
    return onNestingHandler(list, serviceName)
}
